import { DEFAULTS } from "./defaults";
import { LINK_PREVIEW_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginLinkPreview = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINK_PREVIEW_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginLinkPreview
};
//# sourceMappingURL=viewer-loadable.js.map
